var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHuddledeckRoadblock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.547,
    viewBox: "0 0 20 17.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1525 -218.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 7.75,
    transform: "translate(1526.002 222.75)",
    fill: "#ffcf0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.965,28.075a1.035,1.035,0,0,0-1.035,1.034v1.676H2.069V29.109a1.034,1.034,0,0,0-2.069,0V44.587a1.034,1.034,0,0,0,2.069,0V40.448H17.931v4.139a1.034,1.034,0,0,0,2.069,0V29.109A1.035,1.035,0,0,0,18.965,28.075ZM2.112,39.069V34.612l1.209-2.447H6.4l-2.458,6.9Zm4.958,0,2.458-6.9h3.077l-2.458,6.9Zm10.646-4.685-1.362,4.685H13.276l2.458-6.9h1.981Z",
    transform: "translate(1525 190.924)",
    fill: "#283e76"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuddledeckRoadblock);
export default __webpack_public_path__ + "static/media/huddledeck-roadblock.45c28294a95c6b50f9db0ce47e4eeec8.svg";
export { ForwardRef as ReactComponent };